$(document).ready(function() {
  $('.drawer').drawer({
    iscroll: {
      // Configuring the iScroll
      // https://github.com/cubiq/iscroll#configuring-the-iscroll
      mouseWheel: false,
      preventDefault: false
    },
  });
});